export const BOARD_SIZE = 19;

// Tọa độ các điểm sao (Hoshi) trên bàn 19x19
export const STAR_POINTS = [
  [3, 3],
  [3, 9],
  [3, 15],
  [9, 3],
  [9, 9],
  [9, 15],
  [15, 3],
  [15, 9],
  [15, 15],
];
